/* global $ */

// Resize page elements on various events
$(window).resize(function () {
  resizePageElems()
  resetElemsOnResize()
})

resizePageElems()

export function resizePageElems () {
  const windowWidth = $(window).width()
  const windowHeight = $(window).height()
  const smallSize = 700
  const mediumSize = 1000

  // Reduce the height of the main menu if to fit the viewport if not enough room
  const $menuWrapper = $('.hidden-menu__levels-wrapper')

  if (windowHeight < 800) {
    let heightToTakeOff = 50
    if (windowWidth < mediumSize) {
      heightToTakeOff = 50
    }
    $menuWrapper.css('height', windowHeight - heightToTakeOff - $('header').height())
  } else {
    $menuWrapper.css('height', 550)
  }

  // Program navigation same height as the program identification when medium and up
  const $topRightSide = $('#top-separated-right')
  $topRightSide.css('padding', 20)
  if (windowWidth > smallSize) {
    const leftSideHeight = $('#top-separated-left').height()
    const rightSideHeight = $topRightSide.height()

    if (rightSideHeight < leftSideHeight - 40) {
      const newPadding = (leftSideHeight - rightSideHeight) / 2
      $topRightSide.css('padding-top', newPadding)
      $topRightSide.css('padding-bottom', newPadding)
    }
  }

  // Previously in enquire.js
  if (windowWidth >= mediumSize) {
    $('#additional-content').prepend($('#top-additional-content'))
    // $("#main-content").addClass("sync-height");
    // $("#additional-content").addClass("sync-height");
  } else {
    $('#main-content').prepend($('#top-additional-content'))
  }

  $('.footer-navs .section-name').off('click')
  if (windowWidth < smallSize) {
    /* Show childs on mobile version */
    /* Show childs on mobile version */
    $('.footer-navs .section-name').on('click', function () {
      $(this).parents('nav').find('ul').slideToggle()
    })
  } else {
    $('.footer-navs nav ul').show()
  }
}

export function resetElemsOnResize () {
  const windowWidth = $(window).width()
  const mediumSize = 1000

  if (windowWidth >= mediumSize) {
    $('.hidden-menu__level-3').css('left', '0%')
    $('.hidden-menu__level-4').css('left', '33.33%')
    $('.hidden-menu__level-3, .hidden-menu__level-4').hide()
    $('.hidden-menu').hide()
    $('body').css('overflow', 'inherit')
    $('.header__sub-meta-nav').hide()
    $('.main-nav .icon__close').addClass('icon__chevron--down').removeClass('icon__close')
  }
}
